var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',{staticClass:"p-0",attrs:{"md":"12"}},[_c('div',[_c('Slider',{attrs:{"items":_vm.params['slider_items'],"settings":_vm.slider_settings,"page":'investors'}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }